import { qk, useSession } from '@sunucupark/client-react';
import type { MailFolder } from '@sunucupark/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { unreadOf } from './unread';
import { useWebClient } from './use-web-client';

/**
 * Keeps the tab title and the favicon in step with the unread mail. It renders
 * nothing: the count comes from the folder list the shell already loads, so no
 * extra request is made (ADR 0006).
 */
export function UnreadBadge() {
  const client = useWebClient();
  const queryClient = useQueryClient();
  const session = useSession();
  const accountId = session?.accountId;
  const badge = client.platform?.badge;

  useEffect(() => {
    if (!accountId || !badge) return;
    const key = qk.folders(accountId);
    const apply = () => badge.set(unreadOf(queryClient.getQueryData<MailFolder[]>(key)));
    apply();
    const unsubscribe = queryClient.getQueryCache().subscribe(() => apply());
    return () => {
      unsubscribe();
      badge.set(0);
    };
  }, [accountId, badge, queryClient]);

  return null;
}
